module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/vertical/atheroma/after_treatment_icon-319446f57cbff0966cee90e0610cc5f4.png";